// extracted by mini-css-extract-plugin
export default {"OpenJobworkListPage":"OpenJobworkListPage_OpenJobworkListPage__JIzKg"};